<button
  class="tertiary-btn export-cart"
  (click)="downloadCartCsv()"
  [class.disabled]="showSrp && pageId !== 'savedCartDetailsPage'"
  [disabled]="showSrp && pageId !== 'savedCartDetailsPage'"
>
  <mat-icon svgIcon="exportfile" class="mr-1" [class.disabled]="showSrp && pageId !== 'savedCartDetailsPage'"></mat-icon
  >{{ 'cart.cartAction.export' | cxTranslate }}
</button>
